import React from 'react';
import { SearchBox, SearchBoxProps } from './SearchBox';
import { declareWithDefaults } from '../../helpers/typescript';
import { fontFamilies } from '../../helpers/fonts';

export type SearchBoxWithRoundedCornersProps = SearchBoxProps;
const Component: React.FC<SearchBoxWithRoundedCornersProps> = props => {
  return <SearchBox {...props} />;
};

const defaultProps = {
  backgroundColor: 'white',
  border: '1px solid black',
  borderRadius: '5px',
  disableEnterSubmit: true,
  inputStyle: {
    fontFamily: fontFamilies.light,
    fontSize: '13px',
    fontWeight: 100,
  },
  padding: '0 12px',
  size: { height: '40px', width: '220px' },
};
export const SearchBoxWithRoundedCorners = declareWithDefaults<
  SearchBoxWithRoundedCornersProps,
  keyof typeof defaultProps
>(Component, defaultProps);
